(() => {
const header = document.querySelector('[data-header]');
const menuButton = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-menu]');

window.addEventListener('scroll', () => {
  header?.classList.toggle('is-scrolled', window.scrollY > 24);
}, { passive: true });

menuButton?.addEventListener('click', () => {
  const open = menuButton.getAttribute('aria-expanded') === 'true';
  menuButton.setAttribute('aria-expanded', String(!open));
  menu?.classList.toggle('is-open', !open);
});

menu?.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => {
    menuButton?.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-open');
  });
});

document.querySelectorAll('[data-shop]').forEach((shop) => {
  const filters = shop.querySelectorAll('[data-filter]');
  const products = shop.querySelectorAll('[data-range]');

  filters.forEach((button) => {
    button.addEventListener('click', () => {
      const selected = button.dataset.filter;
      filters.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      products.forEach((product) => {
        product.hidden = selected !== 'all' && product.dataset.range !== selected;
      });
    });
  });
});

const reviewMarquee = document.querySelector('.reviews__marquee');

if (reviewMarquee && 'IntersectionObserver' in window) {
  const reviewObserver = new IntersectionObserver(([entry]) => {
    reviewMarquee.classList.toggle('is-paused', !entry.isIntersecting || document.hidden);
  }, { threshold: 0.08 });

  reviewObserver.observe(reviewMarquee);
  document.addEventListener('visibilitychange', () => {
    reviewMarquee.classList.toggle('is-paused', document.hidden);
  });
}

const cartTrustCopy = new Map([
  ['Money back if the Sleeves roll down', 'Certified Sun Protection'],
  ['100% Safe & Secure Checkout', 'Secure Checkout'],
  ['Fast & Easy Returns', 'Easy Returns — Conditions Apply']
]);

const updateCartTrustCopy = () => {
  const cart = document.querySelector('#kaching-cart');
  if (!cart) return;

  const walker = document.createTreeWalker(cart, NodeFilter.SHOW_TEXT);
  let textNode;

  while ((textNode = walker.nextNode())) {
    const original = textNode.nodeValue.trim();
    const replacement = cartTrustCopy.get(original);
    if (replacement) textNode.nodeValue = replacement;
  }
};

updateCartTrustCopy();
new MutationObserver(updateCartTrustCopy).observe(document.documentElement, {
  childList: true,
  subtree: true
});

const normaliseProductImage = (image) => {
  if (!image.complete || !image.naturalWidth || !image.naturalHeight) return;

  try {
    const maximum = 220;
    const ratio = Math.min(1, maximum / Math.max(image.naturalWidth, image.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.naturalWidth * ratio));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * ratio));
    const context = canvas.getContext('2d', { willReadFrequently: true });
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
    const corners = [0, canvas.width - 1, (canvas.height - 1) * canvas.width, (canvas.height * canvas.width) - 1];
    const background = corners.reduce((colour, index) => {
      const offset = index * 4;
      colour[0] += pixels[offset];
      colour[1] += pixels[offset + 1];
      colour[2] += pixels[offset + 2];
      return colour;
    }, [0, 0, 0]).map((channel) => channel / corners.length);
    let minimumX = canvas.width;
    let minimumY = canvas.height;
    let maximumX = -1;
    let maximumY = -1;
    const columnCounts = new Uint16Array(canvas.width);
    const rowCounts = new Uint16Array(canvas.height);

    for (let y = 0; y < canvas.height; y += 1) {
      for (let x = 0; x < canvas.width; x += 1) {
        const offset = ((y * canvas.width) + x) * 4;
        const difference = Math.max(
          Math.abs(pixels[offset] - background[0]),
          Math.abs(pixels[offset + 1] - background[1]),
          Math.abs(pixels[offset + 2] - background[2])
        );
        const darkestChannel = Math.min(pixels[offset], pixels[offset + 1], pixels[offset + 2]);
        if (pixels[offset + 3] > 20 && darkestChannel < 240) {
          minimumX = Math.min(minimumX, x);
          maximumX = Math.max(maximumX, x);
          minimumY = Math.min(minimumY, y);
          maximumY = Math.max(maximumY, y);
          columnCounts[x] += 1;
          rowCounts[y] += 1;
        }
      }
    }

    if (maximumX < 0 || maximumY < 0) return;
    const columnThreshold = Math.max(2, Math.round(canvas.height * 0.012));
    const rowThreshold = Math.max(2, Math.round(canvas.width * 0.012));
    const robustMinimumX = columnCounts.findIndex((count) => count >= columnThreshold);
    const robustMinimumY = rowCounts.findIndex((count) => count >= rowThreshold);
    const robustMaximumXFromEnd = Array.from(columnCounts).reverse().findIndex((count) => count >= columnThreshold);
    const robustMaximumYFromEnd = Array.from(rowCounts).reverse().findIndex((count) => count >= rowThreshold);
    if (robustMinimumX >= 0 && robustMaximumXFromEnd >= 0) {
      minimumX = robustMinimumX;
      maximumX = canvas.width - robustMaximumXFromEnd - 1;
    }
    if (robustMinimumY >= 0 && robustMaximumYFromEnd >= 0) {
      minimumY = robustMinimumY;
      maximumY = canvas.height - robustMaximumYFromEnd - 1;
    }
    const contentWidth = (maximumX - minimumX + 1) / canvas.width;
    const contentHeight = (maximumY - minimumY + 1) / canvas.height;
    const isStudioImage = background.every((channel) => channel > 245);
    let scale = Math.min(1.3, Math.max(1, Math.min(0.86 / contentWidth, 0.88 / contentHeight)));
    if (isStudioImage) scale = Math.max(1.18, scale);
    if (image.closest('.yv-pdp__main-image--tropical-geo')) scale = Math.max(1.3, scale);
    image.style.setProperty('--yv-image-scale', scale.toFixed(3));
  } catch (error) {
    image.style.removeProperty('--yv-image-scale');
  }
};

const productImageStyle = document.createElement('style');
productImageStyle.textContent = '.yv-pdp__main-image img[data-yv-main-image]{transform:scale(var(--yv-image-scale,1))!important}';
document.head.append(productImageStyle);

document.querySelectorAll('[data-yv-main-image]').forEach((image) => {
  if (image.complete) normaliseProductImage(image);
  else image.addEventListener('load', () => normaliseProductImage(image), { once: true });
});

const bagLink = document.querySelector('.bag-link');
const originalFetch = window.fetch.bind(window);
let bagSyncTimer;

const renderBagCount = (count) => {
  if (!bagLink) return;

  let badge = bagLink.querySelector('[data-youvee-bag-count]');

  if (!badge) {
    badge = document.createElement('span');
    badge.dataset.youveeBagCount = '';
    badge.setAttribute('aria-hidden', 'true');
    bagLink.append(badge);
  }

  badge.textContent = String(count);
  badge.hidden = count < 1;

  bagLink.setAttribute(
    'aria-label',
    count === 1 ? 'Bag, 1 item' : `Bag, ${count} items`
  );
};

const syncBagCount = async () => {
  if (!bagLink) return;

  try {
    const root = window.Shopify?.routes?.root || '/';

    const response = await originalFetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) return;

    const cart = await response.json();
    renderBagCount(cart.item_count || 0);
  } catch (error) {
    console.error(error);
  }
};

const scheduleBagSync = () => {
  window.clearTimeout(bagSyncTimer);
  bagSyncTimer = window.setTimeout(syncBagCount, 350);
  window.setTimeout(syncBagCount, 1200);
};

window.fetch = async (...args) => {
  const response = await originalFetch(...args);

  const requestUrl =
    typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

  if (
    response.ok &&
    /\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(requestUrl)
  ) {
    scheduleBagSync();
  }

  return response;
};

document.addEventListener('submit', (event) => {
  if (event.target.matches('form[action*="/cart/add"]')) {
    scheduleBagSync();
  }
}, true);

document.addEventListener('cart:rerender', scheduleBagSync);
window.addEventListener('pageshow', syncBagCount);

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) syncBagCount();
});

const bagCountStyle = document.createElement('style');

bagCountStyle.textContent =
  '[data-youvee-bag-count]{display:inline-grid;place-items:center;min-width:1.15rem;height:1.15rem;margin-left:.3rem;padding:0 .25rem;border-radius:999px;background:#e85f6a;color:#fff;font-size:.68rem;font-weight:700;line-height:1}[data-youvee-bag-count][hidden]{display:none}';

document.head.append(bagCountStyle);
syncBagCount();
document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-yv-thumb]');

  if (thumbnail) {
    const section = thumbnail.closest('[data-youvee-product]');
    const mainImage = section?.querySelector('[data-yv-main-image]');
    if (!mainImage) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    mainImage.classList.add('is-changing');
    mainImage.addEventListener('load', () => {
      normaliseProductImage(mainImage);
      mainImage.classList.remove('is-changing');
    }, { once: true });
    mainImage.src = thumbnail.dataset.imageSrc;
    mainImage.srcset = '';
    mainImage.alt = thumbnail.dataset.imageAlt || '';
    section.querySelectorAll('[data-yv-thumb]').forEach((item) => {
      const active = item === thumbnail;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    return;
  }

  const swatch = event.target.closest('.yv-pdp__swatch[href]');
  if (!swatch) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(swatch.href);
}, true);
document.addEventListener('click', async (event) => {
  const cartButton = event.target.closest(
    '.kaching-cart-item__remove-btn, [data-cart-item-remove], [data-increase-quantity], [data-decrease-quantity]'
  );

  if (!cartButton || cartButton.dataset.youveeUpdating === 'true') return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const kachingItem = cartButton.closest('.kaching-cart-item');
  const nativeActions = cartButton.closest('cart-actions');

  let line = 0;
  let quantity = 0;

  if (kachingItem) {
    const cartItems = Array.from(
      document.querySelectorAll('.kaching-cart-item')
    );

    line = cartItems.indexOf(kachingItem) + 1;
  } else if (nativeActions) {
    line = Number.parseInt(nativeActions.dataset.line, 10);
    quantity = Number.parseInt(cartButton.dataset.quantity, 10);
  }

  if (
    !Number.isInteger(line) ||
    line < 1 ||
    !Number.isInteger(quantity) ||
    quantity < 0
  ) {
    return;
  }

  cartButton.dataset.youveeUpdating = 'true';
  cartButton.disabled = true;

  try {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line, quantity })
    });

    if (!response.ok) {
      throw new Error('Unable to update cart item');
    }

    const cart = await response.json();
    renderBagCount(cart.item_count || 0);

    if (kachingItem) {
      kachingItem.remove();
    } else {
      const refreshUrl = new URL(window.location.href);
      refreshUrl.searchParams.set(
        'cart_refresh',
        Date.now().toString()
      );
      window.location.replace(refreshUrl.toString());
    }
  } catch (error) {
    cartButton.dataset.youveeUpdating = 'false';
    cartButton.disabled = false;
    console.error(error);
  }
}, true);
})();
